"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StarFillYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_StarFillYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.194 5.194 15.76c-1.372.765-3.014-.402-2.762-1.963l.56-3.462-2.456-2.54C-.532 6.692.086 4.832 1.596 4.6l3.309-.51 1.395-3c.676-1.452 2.724-1.452 3.4 0l1.395 3 3.308.51c1.512.232 2.129 2.092 1.061 3.196l-2.456 2.54.56 3.46c.252 1.562-1.39 2.73-2.762 1.964L8 14.194Z",
    fill: "gold"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_StarFillYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_StarFillYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8 13.05 3.293 1.836c.624.348 1.41-.174 1.288-.93l-.64-3.957 2.804-2.9c.512-.529.203-1.405-.494-1.512l-3.837-.592-1.62-3.483a.871.871 0 0 0-1.587 0L5.586 4.995l-3.837.592c-.697.107-1.006.983-.494 1.513L4.059 10l-.64 3.955c-.122.757.664 1.279 1.288.93L8 13.05Zm-5.008-2.716-.56 3.462c-.252 1.56 1.39 2.728 2.762 1.963L8 14.194l2.806 1.565c1.372.765 3.014-.402 2.762-1.963l-.56-3.462 2.456-2.54c1.068-1.103.45-2.963-1.06-3.195l-3.309-.51-1.395-3c-.676-1.452-2.724-1.452-3.4 0l-1.395 3-3.309.51C.086 4.83-.532 6.69.536 7.795l2.456 2.54Z",
    fill: "#B36200"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_StarFillYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B36200",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = StarFillYes;
exports["default"] = _default;